export default __webpack_public_path__ + "static/media/Renewi_logo.b625a098.svg";